import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const repairOrderItemsAdapter = getAdapter({ idFieldName: 'value' });

const repairOrderItemsSlice = createSlice({
  name: 'repairOrderItems',
  initialState: repairOrderItemsAdapter.getInitialState(),
  reducers: {
    setRepairOrderItems: (state, { payload: { repairOrderItems } }) => {
      repairOrderItemsAdapter.setAll(state, repairOrderItems);
    },
  },
});

const selectors = repairOrderItemsAdapter.getSelectors(({ repairOrderItems }) => repairOrderItems);

export const getRepairOrderItems = (state) => selectors.selectAll(state);

export const { setRepairOrderItems } = repairOrderItemsSlice.actions;

export default repairOrderItemsSlice.reducer;
